<template>
  <div class="mainContent">
    <h5>Tiene un préstamo esperando reembolso</h5>
    <div class="repayBox">
      <!-- left repay info -->
      <div class="leftInfoBox">
        <div>
          <p style="width:2.38rem">Monto de préstamo</p>
          <h3>S/{{ $setNum(unpaid_amount) }}</h3>
        </div>
        <div>
          <p>Fecha de pago</p>
          <h3>{{ $setMoment(repay_time, 1, 1) }}</h3>
        </div>
        <p class="numDetail" @click="jumpDetail">
          Detalles de la tarifa de su préstamo
        </p>
      </div>
      <!-- right repay num -->
      <div class="rightNumBox">
        <h3>Ingrese el monto del reembolso</h3>
        <el-input
          style="display:block"
          @input="changeAmount"
          v-model="acctAmount"
          oninput="this.value=this.value.replace(/\D/g,'')"
          onafterpaste="this.value=this.value.replace(/\D/g,'')"
        >
          <template slot="prepend">S/</template>
          <template slot="append">
            <img src="../../assets/webImg/iptIcon.png" alt="" />
          </template>
        </el-input>
        <p class="repayTip">{{ descText }}</p>
      </div>
    </div>

    <!-- choose Bank -->
    <div class="chooseBankBox">
      <h3>Elegir un método de pago</h3>
      <!-- repayment Bnak choose -->
      <div class="bankListBox">
        <el-radio-group v-model="chooseBank" @change="changeRadio">
          <el-radio
            v-for="(item, index) in bankList"
            :key="index"
            :label="item.channelList[0].name"
          >
            <template>
              <img :src="item.channelList[0].logo" alt="" />
              {{ item.channelList[0].name }}
            </template>
          </el-radio>
        </el-radio-group>
      </div>
    </div>

    <!-- repayment Btn -->
    <div @click="subRepayment" class="subRepayment">
      Realice su pago en estos momentos（{{ totalAmount }}）
    </div>

    <!-- info Detail -->
    <el-dialog
      title="Detalles del préstamo"
      :visible.sync="detailShow"
      width="30%"
    >
      <div>
        <ul class="loadDetail">
          <li>
            <p>Fecha de vencimiento</p>
            <p>{{ $setMoment(reloanInfo.repay_time, 1, 1) }}</p>
          </li>
          <li>
            <p>Monto depositado</p>
            <p>S/ {{ $setNum(reloanInfo.loan_amount) }}</p>
          </li>
          <li>
            <p>Monto de pago total</p>
            <p>S/ {{ $setNum(reloanInfo.total_amount_due) }}</p>
          </li>
          <li>
            <p>Interés</p>
            <p>S/ {{ $setNum(reloanInfo.interest) }}</p>
          </li>
          <li>
            <p>Cargo de servicios</p>
            <p>S/ {{ $setNum(reloanInfo.service_fee) }}</p>
          </li>
          <li>
            <p>IGV</p>
            <p>S/ {{ $setNum(reloanInfo.vat) }}</p>
          </li>
          <li>
            <p>Monto pagado</p>
            <p>S/ {{ $setNum(reloanInfo.paid_amount) }}</p>
          </li>
          <li v-show="orderState == 9">
            <p>Interés penalizado</p>
            <p>S/ {{ $setNum(reloanInfo.penalty_amount) }}</p>
          </li>
        </ul>
      </div>
      <el-button @click="detailShow = false" class="closeBtn">Close</el-button>
    </el-dialog>
  </div>
</template>

<script>
import {
  repayMentInfo,
  createRepayment,
  repaymentDesc,
  getRepaymentList,
} from "../../utils/api/h5page";
export default {
  name: "",
  components: {},
  props: {
    orderState: {
      type: Number,
    },
  },
  data() {
    return {
      detailShow: false,
      repay_time: "",
      unpaid_amount: 0,
      acctAmount: "",
      chooseBank: "",
      chooseBankData: {},
      bankList: [],
      getFees: null,
      descText: "",
      totalAmount: 0,
      orderId: "",
      reloanInfo: {},
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getRpaymentInfo();
    this.repaymentList();
  },
  methods: {
    // catch repayment Detail
    jumpDetail() {
      this.detailShow = true;
    },

    // submit Btn
    subRepayment() {
      if (!this.acctAmount) {
        return this.$Toast("Please fill in the repayment amount");
      }
      const params = {
        orderId: this.orderId,
        acctCouponId: -1,
        acctAmount: Number(this.acctAmount),
        ...this.chooseBankData,
      };
      this.$emit("openLoading");
      createRepayment(params).then(({ data }) => {
        if (data.code == 0) {
          this.$emit("closeLoading");
          window.location.href = data.data.token;
        } else {
          this.$emit("closeLoading");
        }
      });
    },
    // 更换还款金额
    changeAmount() {
      if (this.acctAmount > this.unpaid_amount) {
        this.acctAmount = this.unpaid_amount;
      }
      if (this.getFees) clearTimeout(this.getFees);
      this.getFees = setTimeout(() => {
        this.computDesc();
      }, 500);
    },
    // 计算手续费
    computDesc() {
      repaymentDesc({
        ...this.chooseBankData,
        payAmount: Number(this.acctAmount),
      }).then(({ data }) => {
        console.log(data);
        this.descText = data.data.desc;
        this.totalAmount = data.data.totalAmount;
        clearTimeout(this.getFees);
      });
    },
    // 获取还款信息
    getRpaymentInfo() {
      repayMentInfo().then(({ data }) => {
        this.unpaid_amount = data.data.info.unpaid_amount;
        this.acctAmount = this.unpaid_amount;
        this.repay_time = data.data.info.repay_time;
        this.reloanInfo = data.data.info;
        this.orderId = data.data.info.order_id.toString();
      });
    },

    // 获取还款通道
    repaymentList() {
      getRepaymentList().then(({ data }) => {
        if (data.code == 0) {
          this.bankList = data.data.channelInfo;
          // 银行卡默认选择第一个
          this.chooseBankData.payType = this.bankList[0].payType;
          this.chooseBankData.channelNo = this.bankList[0].channelList[0].channelNo;
          this.chooseBank = this.bankList[0].channelList[0].name;
          this.getFees = setTimeout(() => {
            this.computDesc();
          }, 500);
        } else {
          // this.$Toast(data.message);
        }
      });
    },

    // 更换还款通道
    changeRadio(val) {
      this.bankList.map((item) => {
        if (val == item.channelList[0].name) {
          this.chooseBankData.payType = item.payType;
          this.chooseBankData.channelNo = item.channelList[0].channelNo;
        }
      });
      setTimeout(() => {
        this.computDesc();
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.mainContent {
  width: 11.3rem;
  margin: 0.47rem auto 0;
  h5 {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.24rem;
    color: #333333;
    line-height: 0.33rem;
    margin-bottom: 0.26rem;
    padding-left: 0.2rem;
  }
  .repayBox {
    display: flex;
    justify-content: center;
    .leftInfoBox {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.3rem;
      width: 4.9rem;
      height: 2.4rem;
      background: #c90000;
      border-radius: 0.2rem;
      margin-right: 0.6rem;
      div {
        height: 1.01rem;
        p {
          font-family: Roboto, Roboto;
          font-weight: 400;
          font-size: 0.2rem;
          color: #ffffff;
          margin-bottom: 0.2rem;
        }
        h3 {
          font-family: Roboto, Roboto;
          font-weight: 500;
          font-size: 0.27rem;
          color: #ffffff;
        }
      }
      .numDetail {
        cursor: pointer;
        position: absolute;
        right: 0.38rem;
        bottom: 0.22rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.18rem;
        color: #ffffff;
        text-decoration-line: underline;
      }
    }
    .rightNumBox {
      width: 5.4rem;
      height: 2.4rem;
      background: #ffffff;
      box-shadow: 0rem -0.02rem 0rem 0rem #5961ff;
      border-radius: 0.2rem;
      border: 0.01rem solid #979797;
      padding: 0.35rem 0.45rem 0;
      h3 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.18rem;
        color: #333333;
        text-align: center;
        margin-bottom: 0.18rem;
      }
      /deep/ .el-input {
        display: flex !important;
      }
      /deep/ .el-input-group__prepend,
      /deep/ .el-input-group__append {
        background: #fafafa;
        display: flex;
        align-items: center;
        font-family: Roboto, Roboto;
        font-weight: 500;
        font-size: 0.36rem;
        color: #333333;
      }
      /deep/ .el-input-group__prepend {
        border-top-left-radius: 0.1rem;
        border-bottom-left-radius: 0.1rem;
      }
      /deep/ .el-input-group__append {
        width: 0.64rem;
        border-top-right-radius: 0.1rem;
        border-bottom-right-radius: 0.1rem;
        padding: 0;
        img {
          width: 0.34rem;
          height: 0.34rem;
        }
      }
      /deep/ .el-input__inner {
        height: 0.83rem;
        background: #fafafa;
        border: 0.01rem solid #e7e7e7;
        border-left: none;
        border-right: none;
        font-family: Roboto, Roboto;
        font-weight: 500;
        font-size: 0.36rem;
        color: #333333;
        padding-left: 0.25rem;
      }
      .repayTip {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.14rem;
        color: #666666;
        margin-top: 0.18rem;
        text-align: right;
      }
    }
  }

  .chooseBankBox {
    margin-top: 0.6rem;
    width: 100%;
    h3 {
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 0.24rem;
      color: #333333;
    }
    .bankListBox {
      width: 100%;
      padding: 0.3rem 0.24rem 0.32rem;
      background: #ffffff;
      border-radius: 0.2rem;
      margin: 0.4rem 0;
      img {
        width: 0.6rem;
        height: 0.6rem;
        margin-right: 0.15rem;
      }
      /deep/ .el-radio-group {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      /deep/ .el-radio {
        width: 4.38rem;
        display: flex;
        justify-content: space-between;
        flex-direction: row-reverse;
        margin: 0 0 0.12rem 0;
      }
      /deep/ .el-radio__label {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.2rem;
        color: #666666;
        display: flex;
        align-items: center;
      }
      /deep/ .el-radio__inner {
        border: 1px solid #9e9e9e;
        width: 0.2rem;
        height: 0.2rem;
      }
      /deep/ .el-radio__input {
        display: flex;
        align-items: center;
      }
      /deep/ .el-radio__input.is-checked .el-radio__inner {
        width: 0.2rem;
        height: 0.2rem;
        border: 0.03rem solid #c90000;
        background: #fff;
      }
      /deep/ .el-radio__inner::after {
        background-color: #c90000;
        width: 0.11rem;
        height: 0.11rem;
      }
    }
  }

  .subRepayment {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    width: 7.5rem;
    height: 1.14rem;
    background: #c90000;
    box-shadow: inset 0rem 0.16rem 0.32rem 0rem rgba(255, 255, 255, 0.22);
    border-radius: 0.57rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.32rem;
    color: #ffffff;
  }
}

/deep/ .el-dialog {
  border-radius: 0.2rem;
}

/deep/ .el-dialog__header {
  padding: 0.3rem 0.2rem 0.1rem;
}

/deep/ .el-dialog__title {
  display: block;
  font-size: 0.26rem;
  font-weight: 700;
}

/deep/ .el-dialog__close {
  font-size: 0.26rem;
}

/deep/ .el-dialog__body {
  padding: 0.1rem 0.2rem;
}

.loadDetail {
  li {
    display: flex;
    justify-content: space-between;
    padding: 0.15rem 0.2rem;
    p {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.21rem;
      color: #333333;
    }
  }
}

.closeBtn {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0.2rem auto;
  width: 1.6rem;
  height: 0.5rem;
  border-radius: 0.5rem;
  background: #c90000;
  font-size: 0.26rem;
  color: #ffffff;
  padding: 0;
}

.el-button:focus,
.el-button:hover {
  background: #c90000;
  color: #ffffff;
  border: none;
}
</style>
